export const brandList = [
    {
      brandCode: "CCD",
      logo: "https://designway.github.io/images/img/rensure/carcompare_direct_logo.png",
      brandName: "CarCompare Direct",
      brandStyling: {
        bgColor: "#000",
        headerBg: "#3662ff",
        bgImgLink: "https://designway.github.io/images/img/rensure/blue-bg.png",
        highlightColor: "#D7E2F2",
        boxColor: "#F0F4FA",
        paymentHeaderColor: "#D7E2F2",
        paymentFinalColor: "#E7EFFB",
        buttonColor: "#3662ff",
      },
      img: "",
    },
    {
      brandCode: "VCD",
      logo: "https://designway.github.io/images/img/rensure/vancompare_direct_logo.png",
      brandName: "VanCompare Direct",
      brandStyling: {
        bgColor: "#000",
        headerBg: "#3662ff",
        bgImgLink: "https://designway.github.io/images/img/rensure/blue-bg.png",
        highlightColor: "#D7E2F2",
        boxColor: "#F0F4FA",
        paymentHeaderColor: "#D7E2F2",
        paymentFinalColor: "#D7E2F2",
        buttonColor: "#3662ff",
      },
      img: "",
    },
    {
      brandCode: "CLD",
      logo: "https://designway.github.io/images/img/rensure/carline_direct_logo.png",
      brandName: "Car LineDirect",
      brandStyling: {
        bgColor: "",
        headerBg: "#553DE8",
        bgImgLink: "https://designway.github.io/images/img/rensure/blue-bg.png",
        highlightColor: "#EDE6FC",
        boxColor: "#F8F5FF",
        paymentHeaderColor: "#EDE6FC",
        paymentFinalColor: "#EDE6FC",
        buttonColor: "#553DE8",
      },
      img: "",
    },
    {
      brandCode: "VLD",
      logo: "https://designway.github.io/images/img/rensure/van-line-logo.png",
      brandName: "Van LineDirect",
      brandStyling: {
        bgColor: "#ece9fa",
        headerBg: "#553DE8",
        bgImgLink: "",
        highlightColor: "#EDE6FC",
        boxColor: "#F8F5FF",
        paymentHeaderColor: "#EDE6FC",
        paymentFinalColor: "#EDE6FC",
        buttonColor: "#553DE8",
      },
      img: "",
    },
    {
      brandCode: "VIUK",
      logo: "https://designway.github.io/images/img/rensure/vi_co_uk_logo.png",
      brandName: "Van Insurance.co.uk",
      brandStyling: {
        bgColor: "#000",
        headerBg: "#1563EC",
        bgImgLink: "https://designway.github.io/images/img/rensure/blue-bg.png",
        highlightColor: "#D7E2F2",
        boxColor: "#F0F4FA",
        paymentHeaderColor: "#D7E2F2",
        paymentFinalColor: "#D7E2F2",
        buttonColor: "#3662ff",
      },
      img: "",
    },
    {
      brandCode: "BLD",
      logo: "https://designway.github.io/images/img/rensure/bike-line-logo.png",
      brandName: "Bike LineDirect",
      brandStyling: {
        bgColor: "#ece9fa",
        headerBg: "#553DE8",
        bgImgLink: "",
        highlightColor: "#EDE6FC",
        boxColor: "#F8F5FF",
        paymentHeaderColor: "#EDE6FC",
        paymentFinalColor: "#EDE6FC",
        buttonColor: "#553DE8",
      },
      img: "",
    },
    {
      brandCode: "BIUK",
      logo: "https://designway.github.io/images/img/rensure/bi_co_uk_logo.png",
      brandName: "Bike Insurance.co.uk",
      brandStyling: {
        bgColor: "#000",
        headerBg: "#3662ff",
        bgImgLink: "https://designway.github.io/images/img/rensure/blue-bg.png",
        highlightColor: "#D7E2F2",
        boxColor: "#F0F4FA",
        paymentHeaderColor: "#D7E2F2",
        paymentFinalColor: "#D7E2F2",
        buttonColor: "#553DE8",
      },
      img: "",
    },
    {
      brandCode: "BC",
      logo: "https://designway.github.io/images/img/rensure/bc-logo.png",
      brandName: "BusinessCompare",
      brandStyling: {
        bgColor: "#dcecff",
        headerBg: "#3662ff",
        bgImgLink: "",
        highlightColor: "#D7E2F2",
        boxColor: "#F0F4FA",
        paymentHeaderColor: "#D7E2F2",
        paymentFinalColor: "#D7E2F2",
        buttonColor: "#3662ff",
      },
      img: "",
    },
    {
      brandCode: "MYB",
      logo: "https://assets.mindyourbusiness.co.uk/email-assets/mind-your-business/brand-on-white.png",
      brandName: "Mind Your Business",
      brandStyling: {
        bgColor: "#eeedf3",
        headerBg: "#7133db",
        bgImgLink: "https://designway.github.io/images/img/rensure/purple-bg.png",
        highlightColor: "#e6deef",
        boxColor: "#f7f2ff",
        paymentHeaderColor: "#e6deef",
        paymentFinalColor: "#e6deef",
        buttonColor: "#7133db",
      },
      img: "",
    },
];

const getBrandDetails = (brandCode: string) =>
  brandList.find((item) => item.brandCode === brandCode);

export default getBrandDetails;
